<div
  *ngIf="accountFlyoutData$ | async as accountFlyoutData"
  class="component account-user generic-component"
  style="display: none"
  data-hj-suppress
>
  <div class="component-content">
    <div
      class="account-profile"
      [mmTestTarget]="isMobileView ? 'account-profile--mobile' : 'account-profile--desktop'"
      (click)="toggleFlyout()"
      (keydown.enter)="toggleFlyout()"
      (keydown.space)="toggleFlyout(); $event.preventDefault()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="isFlyoutOpened"
      [attr.aria-controls]="'account-flyout-menu'"
      [attr.aria-label]="'Open account menu'"
    >
      <div class="user-details">
        <div class="username">
          <span
            *ngIf="
              (!accountFlyoutData.selectedContext && user.organizationName) ||
                accountFlyoutData.selectedContext?.account;
              else email
            "
            >{{
              accountFlyoutData.selectedContext
                ? accountFlyoutData.selectedContext.account?.corporateName
                : user.organizationName
            }}</span
          >

          <ng-template #email>
            <span data-hj-suppress>{{ userName || user.email }}</span>
          </ng-template>
        </div>
        <div class="my-account">
          <span data-hj-suppress>{{ 'CORE.ALL_PAGES.USER_BOX.HEADER.LABEL' | translate }}</span>
        </div>
      </div>
      <div class="user-icon">
        <svg
          *ngIf="
            (!accountFlyoutData.selectedContext && user.organizationName) || accountFlyoutData.selectedContext?.account;
            else avatar
          "
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.9903 16H22.1745V3C22.1745 2.448 21.7231 2 21.1648 2H5.00969C4.45234 2 4 2.448 4 3V29C4 29.552 4.45234 30 5.00969 30H10.0582H16.1163H21.1648C21.3011 30 21.4303 29.972 21.5485 29.924C21.6666 29.972 21.7958 30 21.9321 30H27.9903C28.5487 30 29 29.552 29 29V17C29 16.448 28.5487 16 27.9903 16ZM22.1745 28H26.9806V18H22.1745V28ZM17.126 28H20.1551V4H6.01939V28H9.04847V21C9.04847 20.448 9.50081 20 10.0582 20H16.1163C16.6747 20 17.126 20.448 17.126 21V28ZM11.0679 28H15.1066V22H11.0679V28ZM23.4487 20.739V22.739C23.4487 23.289 23.9031 23.739 24.4584 23.739C25.0147 23.739 25.4681 23.289 25.4681 22.739V20.739C25.4681 20.189 25.0147 19.739 24.4584 19.739C23.9031 19.739 23.4487 20.189 23.4487 20.739ZM16.3899 15.918V13.918C16.3899 13.368 16.8443 12.918 17.3996 12.918C17.955 12.918 18.4093 13.368 18.4093 13.918V15.918C18.4093 16.468 17.955 16.918 17.3996 16.918C16.8443 16.918 16.3899 16.468 16.3899 15.918ZM12.3512 13.918V15.918C12.3512 16.468 12.8055 16.918 13.3609 16.918C13.9162 16.918 14.3706 16.468 14.3706 15.918V13.918C14.3706 13.368 13.9162 12.918 13.3609 12.918C12.8055 12.918 12.3512 13.368 12.3512 13.918ZM8.3124 15.918V13.918C8.3124 13.368 8.76676 12.918 9.32209 12.918C9.87742 12.918 10.3318 13.368 10.3318 13.918V15.918C10.3318 16.468 9.87742 16.918 9.32209 16.918C8.76676 16.918 8.3124 16.468 8.3124 15.918ZM16.3899 7.918V9.918C16.3899 10.468 16.8443 10.918 17.3996 10.918C17.955 10.918 18.4093 10.468 18.4093 9.918V7.918C18.4093 7.368 17.955 6.918 17.3996 6.918C16.8443 6.918 16.3899 7.368 16.3899 7.918ZM12.3512 9.918V7.918C12.3512 7.368 12.8055 6.918 13.3609 6.918C13.9162 6.918 14.3706 7.368 14.3706 7.918V9.918C14.3706 10.468 13.9162 10.918 13.3609 10.918C12.8055 10.918 12.3512 10.468 12.3512 9.918ZM8.3124 7.918V9.918C8.3124 10.468 8.76676 10.918 9.32209 10.918C9.87742 10.918 10.3318 10.468 10.3318 9.918V7.918C10.3318 7.368 9.87742 6.918 9.32209 6.918C8.76676 6.918 8.3124 7.368 8.3124 7.918Z"
            fill="white"
          />
          <mask
            id="mask0_4708_3420"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="4"
            y="2"
            width="25"
            height="28"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.9903 16H22.1745V3C22.1745 2.448 21.7231 2 21.1648 2H5.00969C4.45234 2 4 2.448 4 3V29C4 29.552 4.45234 30 5.00969 30H10.0582H16.1163H21.1648C21.3011 30 21.4303 29.972 21.5485 29.924C21.6666 29.972 21.7958 30 21.9321 30H27.9903C28.5487 30 29 29.552 29 29V17C29 16.448 28.5487 16 27.9903 16ZM22.1745 28H26.9806V18H22.1745V28ZM17.126 28H20.1551V4H6.01939V28H9.04847V21C9.04847 20.448 9.50081 20 10.0582 20H16.1163C16.6747 20 17.126 20.448 17.126 21V28ZM11.0679 28H15.1066V22H11.0679V28ZM23.4487 20.739V22.739C23.4487 23.289 23.9031 23.739 24.4584 23.739C25.0147 23.739 25.4681 23.289 25.4681 22.739V20.739C25.4681 20.189 25.0147 19.739 24.4584 19.739C23.9031 19.739 23.4487 20.189 23.4487 20.739ZM16.3899 15.918V13.918C16.3899 13.368 16.8443 12.918 17.3996 12.918C17.955 12.918 18.4093 13.368 18.4093 13.918V15.918C18.4093 16.468 17.955 16.918 17.3996 16.918C16.8443 16.918 16.3899 16.468 16.3899 15.918ZM12.3512 13.918V15.918C12.3512 16.468 12.8055 16.918 13.3609 16.918C13.9162 16.918 14.3706 16.468 14.3706 15.918V13.918C14.3706 13.368 13.9162 12.918 13.3609 12.918C12.8055 12.918 12.3512 13.368 12.3512 13.918ZM8.3124 15.918V13.918C8.3124 13.368 8.76676 12.918 9.32209 12.918C9.87742 12.918 10.3318 13.368 10.3318 13.918V15.918C10.3318 16.468 9.87742 16.918 9.32209 16.918C8.76676 16.918 8.3124 16.468 8.3124 15.918ZM16.3899 7.918V9.918C16.3899 10.468 16.8443 10.918 17.3996 10.918C17.955 10.918 18.4093 10.468 18.4093 9.918V7.918C18.4093 7.368 17.955 6.918 17.3996 6.918C16.8443 6.918 16.3899 7.368 16.3899 7.918ZM12.3512 9.918V7.918C12.3512 7.368 12.8055 6.918 13.3609 6.918C13.9162 6.918 14.3706 7.368 14.3706 7.918V9.918C14.3706 10.468 13.9162 10.918 13.3609 10.918C12.8055 10.918 12.3512 10.468 12.3512 9.918ZM8.3124 7.918V9.918C8.3124 10.468 8.76676 10.918 9.32209 10.918C9.87742 10.918 10.3318 10.468 10.3318 9.918V7.918C10.3318 7.368 9.87742 6.918 9.32209 6.918C8.76676 6.918 8.3124 7.368 8.3124 7.918Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4708_3420)"></g>
        </svg>

        <ng-template #avatar>
          <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7075 0.865234C7.0325 0.865234 0 7.89774 0 16.5728C0 21.7087 2.46492 26.2689 6.27629 29.1349C9.23244 27.8576 10.3649 27.3408 10.3649 27.3408C10.3649 27.3408 10.6271 27.0865 10.8892 26.4328C11.1515 25.779 10.8892 25.2705 10.8892 25.2705L12.2067 24.9436C12.2067 24.9436 12.0879 22.8008 12.2003 22.8008C12.2189 22.8008 12.1819 22.7438 12.1069 22.6282C11.8743 22.2694 11.2754 21.3461 10.836 19.8097C10.523 19.7698 10.0339 19.3945 9.8406 17.8249C9.67431 16.475 9.946 16.2093 10.221 16.2403C10.2144 16.0917 10.2106 15.942 10.2096 15.7912C9.88778 15.1512 9.43559 14.0178 9.2932 12.4979C9.06413 10.0529 9.92314 7.49679 9.92314 7.49679C9.92314 7.49679 10.7821 8.27475 13.4164 7.38566C16.0507 6.49656 19.3722 6.49656 20.1739 7.71907C20.9757 8.94157 20.6321 9.83066 20.6321 9.83066C20.6321 9.83066 22.8082 11.2754 22.2355 13.4982C21.942 14.6377 21.528 15.5727 21.1942 16.2135C21.1938 16.2223 21.1934 16.2311 21.193 16.2399L21.2199 16.2398C21.4909 16.2173 21.7532 16.4932 21.5893 17.8249C21.3928 19.4202 20.8905 19.7823 20.5783 19.8117C20.1388 21.347 19.5405 22.2697 19.308 22.6283C19.233 22.7438 19.1961 22.8008 19.2147 22.8008C19.327 22.8008 19.2082 24.9436 19.2082 24.9436L20.5257 25.2705C20.5257 25.2705 20.2635 25.779 20.5257 26.4328C20.7879 27.0865 21.05 27.3408 21.05 27.3408C21.05 27.3408 22.1826 27.8576 25.1388 29.1349C28.9501 26.2689 31.4151 21.7087 31.4151 16.5728C31.4151 7.89774 24.3825 0.865234 15.7075 0.865234Z"
              fill="white"
            />
          </svg>
        </ng-template>
        <div *ngIf="isFlyoutOpened" class="arrow" style="display: flex"></div>
      </div>
    </div>
    <div
      *ngIf="accountFlyoutData.flyoutData as flyoutData"
      class="account-flyout"
      [mmTestTarget]="isMobileView ? 'account-flyout--mobile' : 'account-flyout--desktop'"
      [class.open]="isFlyoutOpened"
      id="account-flyout-menu"
      role="menu"
      aria-label="Account menu"
    >
      <div class="overlay-flyout" aria-hidden="true"></div>
      <div class="white-section" [class.dont-overflow]="submenuEntries || isContextsMenuOpened">
        <div class="greet-section">
          <span>{{ 'CORE.ALL_PAGES.USER_BOX.HEADER.LABEL' | translate }}</span>
          <div
            class="close-button"
            (click)="toggleFlyout()"
            (keydown.enter)="toggleFlyout()"
            (keydown.space)="toggleFlyout(); $event.preventDefault()"
            tabindex="0"
            role="button"
            aria-label="Close account menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16px"
              height="16px"
              viewBox="0 0 16 16"
              version="1.1"
            >
              <defs>
                <path
                  d="M13.70725,12.29325 C14.09825,12.68425 14.09825,13.31625 13.70725,13.70725 C13.51225,13.90225 13.25625,14.00025 13.00025,14.00025 C12.74425,14.00025 12.48825,13.90225 12.29325,13.70725 L8.00025,9.41425 L3.70725,13.70725 C3.51225,13.90225 3.25625,14.00025 3.00025,14.00025 C2.74425,14.00025 2.48825,13.90225 2.29325,13.70725 C1.90225,13.31625 1.90225,12.68425 2.29325,12.29325 L6.58625,8.00025 L2.29325,3.70725 C1.90225,3.31625 1.90225,2.68425 2.29325,2.29325 C2.68425,1.90225 3.31625,1.90225 3.70725,2.29325 L8.00025,6.58625 L12.29325,2.29325 C12.68425,1.90225 13.31625,1.90225 13.70725,2.29325 C14.09825,2.68425 14.09825,3.31625 13.70725,3.70725 L9.41425,8.00025 L13.70725,12.29325 Z"
                  id="path-1"
                ></path>
              </defs>
              <g id="Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-/-small-/-close-small">
                  <rect id="fill" x="0" y="0" width="16" height="16"></rect>
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use id="color" fill="#0064FE" xlink:href="#path-1"></use>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div *ngIf="showSSONotice" class="notice-section" role="status">
          <div class="icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 9.99939C0 4.48566 4.48539 0 10 0C15.5146 0 20 4.48566 20 9.99939C20 15.5143 15.5146 20 10 20C4.48539 20 0 15.5143 0 9.99939ZM1.8184 9.99939C1.8184 14.5117 5.48794 18.1815 10 18.1815C14.5108 18.1815 18.1816 14.5117 18.1816 9.99939C18.1816 5.48827 14.5108 1.81851 10 1.81851C5.48794 1.81851 1.8184 5.48827 1.8184 9.99939ZM8.675 5.69766C8.675 4.96783 9.2678 4.375 9.99758 4.375C10.7262 4.375 11.3202 4.96783 11.3202 5.69766C11.3202 6.42749 10.7262 7.02033 9.99758 7.02033C9.2678 7.02033 8.675 6.42749 8.675 5.69766ZM10.8865 15.7859V15.0231V14.3996V13.9674V8.98099C10.8865 8.48295 10.4854 8.07802 9.98888 8.0718C9.99366 8.07176 9.99846 8.07173 10.0033 8.07173H9.97728C9.98115 8.07173 9.98502 8.07176 9.98888 8.0718C9.3735 8.07802 9.06738 8.48295 9.06738 8.98099C9.06738 9.23008 9.06699 9.27667 9.06659 9.32361C9.06619 9.37125 9.06578 9.41925 9.06578 9.67971L9.06808 9.89024V13.9674V14.3217V14.8553V15.7859H10.8865Z"
                fill="#002D72"
              />
            </svg>
          </div>
          <p [innerHTML]="'CORE.ALL_PAGES.FLYOUT.INFO.TEXT' | translate"></p>
        </div>
        <!-- #region Svg Helpers --><!-- #endregion -->
        <div class="switch-section" *ngIf="accountFlyoutData.contexts.length >= 1">
          <div *ngIf="accountFlyoutData.selectedContext?.id === 'personal'" class="switch-account-details">
            <div class="personal-info">
              <div class="personal-info-name">{{ accountFlyoutData.selectedContext?.label }}</div>
              <span class="personal-info-link">{{ accountFlyoutData.selectedContext?.footer }}</span>
            </div>
          </div>

          <div *ngIf="accountFlyoutData.selectedContext?.id !== 'personal'" class="switch-account-container">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.9903 16H22.1745V3C22.1745 2.448 21.7231 2 21.1648 2H5.00969C4.45234 2 4 2.448 4 3V29C4 29.552 4.45234 30 5.00969 30H10.0582H16.1163H21.1648C21.3011 30 21.4303 29.972 21.5485 29.924C21.6666 29.972 21.7958 30 21.9321 30H27.9903C28.5487 30 29 29.552 29 29V17C29 16.448 28.5487 16 27.9903 16ZM22.1745 28H26.9806V18H22.1745V28ZM17.126 28H20.1551V4H6.01939V28H9.04847V21C9.04847 20.448 9.50081 20 10.0582 20H16.1163C16.6747 20 17.126 20.448 17.126 21V28ZM11.0679 28H15.1066V22H11.0679V28ZM23.4487 20.739V22.739C23.4487 23.289 23.9031 23.739 24.4584 23.739C25.0147 23.739 25.4681 23.289 25.4681 22.739V20.739C25.4681 20.189 25.0147 19.739 24.4584 19.739C23.9031 19.739 23.4487 20.189 23.4487 20.739ZM16.3899 15.918V13.918C16.3899 13.368 16.8443 12.918 17.3996 12.918C17.955 12.918 18.4093 13.368 18.4093 13.918V15.918C18.4093 16.468 17.955 16.918 17.3996 16.918C16.8443 16.918 16.3899 16.468 16.3899 15.918ZM12.3512 13.918V15.918C12.3512 16.468 12.8055 16.918 13.3609 16.918C13.9162 16.918 14.3706 16.468 14.3706 15.918V13.918C14.3706 13.368 13.9162 12.918 13.3609 12.918C12.8055 12.918 12.3512 13.368 12.3512 13.918ZM8.3124 15.918V13.918C8.3124 13.368 8.76676 12.918 9.32209 12.918C9.87742 12.918 10.3318 13.368 10.3318 13.918V15.918C10.3318 16.468 9.87742 16.918 9.32209 16.918C8.76676 16.918 8.3124 16.468 8.3124 15.918ZM16.3899 7.918V9.918C16.3899 10.468 16.8443 10.918 17.3996 10.918C17.955 10.918 18.4093 10.468 18.4093 9.918V7.918C18.4093 7.368 17.955 6.918 17.3996 6.918C16.8443 6.918 16.3899 7.368 16.3899 7.918ZM12.3512 9.918V7.918C12.3512 7.368 12.8055 6.918 13.3609 6.918C13.9162 6.918 14.3706 7.368 14.3706 7.918V9.918C14.3706 10.468 13.9162 10.918 13.3609 10.918C12.8055 10.918 12.3512 10.468 12.3512 9.918ZM8.3124 7.918V9.918C8.3124 10.468 8.76676 10.918 9.32209 10.918C9.87742 10.918 10.3318 10.468 10.3318 9.918V7.918C10.3318 7.368 9.87742 6.918 9.32209 6.918C8.76676 6.918 8.3124 7.368 8.3124 7.918Z"
                fill="#002D72"
              />
            </svg>
            <div class="switch-account-details">
              <div class="business-name">{{ accountFlyoutData.selectedContext?.label }}</div>
              <div class="online-only">
                {{ flyoutData.translations[accountFlyoutData?.selectedContext?.account?.onlineStatus || 'onlineOnly'] }}
              </div>
              <div
                class="request-store-access-link"
                *ngIf="
                  accountFlyoutData?.selectedContext?.account?.onlineStatus != 'onlineAndStoreAccess' && !isCompanion
                "
              >
                <a
                  class="menu-entry"
                  href="{{ accountFlyoutData.selectedContext?.account?.actions?.requestStoreAccess }}"
                >
                  {{ flyoutData.translations.requestStoreAccess }}
                </a>
              </div>
            </div>
          </div>

          <div
            class="switch-account"
            (click)="toggleContextsMenu()"
            (keydown.enter)="toggleContextsMenu()"
            (keydown.space)="toggleContextsMenu(); $event.preventDefault()"
            *ngIf="accountFlyoutData.contexts.length > 1"
            tabindex="0"
            role="menuitem"
            [attr.aria-expanded]="isContextsMenuOpened"
            [attr.aria-controls]="'context-menu'"
            aria-label="Switch accounts"
          >
            <div class="switch-account-content">
              <div class="switch-account-svg">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23.0935 16.7974C23.0935 16.6474 23.062 16.5004 23.005 16.3654C22.948 16.2274 22.867 16.1044 22.762 16.0009L22.7605 15.9994L17.404 10.6729C16.966 10.2349 16.2505 10.2364 15.8125 10.6774C15.3745 11.1184 15.3775 11.8309 15.8185 12.2689L19.243 15.6724H3.21851C2.59751 15.6724 2.09351 16.1764 2.09351 16.7974C2.09351 17.4184 2.59751 17.9224 3.21851 17.9224H19.2415L15.817 21.3274C15.3775 21.7669 15.3745 22.4779 15.8125 22.9189C16.0345 23.1394 16.3225 23.2504 16.612 23.2504C16.8985 23.2504 17.1865 23.1409 17.4055 22.9234L22.762 17.5954C22.7875 17.5714 22.798 17.5354 22.8205 17.5084C22.8925 17.4229 22.9615 17.3359 23.005 17.2324C23.062 17.0944 23.0935 16.9489 23.0935 16.7974ZM2.09351 7.20188C2.09351 7.05038 2.12501 6.90338 2.18201 6.76688C2.23901 6.63188 2.32151 6.50888 2.42501 6.40538V6.40388L7.78151 1.07738C8.22251 0.639379 8.93501 0.640879 9.37301 1.08188C9.81101 1.52138 9.80951 2.23538 9.36851 2.67188L5.94551 6.07688H21.9685C22.5895 6.07688 23.0935 6.58088 23.0935 7.20188C23.0935 7.82288 22.5895 8.32688 21.9685 8.32688H5.94551L9.36851 11.7319C9.80951 12.1699 9.81101 12.8824 9.37301 13.3219C9.15401 13.5424 8.86451 13.6534 8.57501 13.6534C8.28851 13.6534 8.00201 13.5454 7.78151 13.3264L2.42501 7.99988V7.99838C2.32151 7.89488 2.23901 7.77188 2.18201 7.63688C2.12501 7.50038 2.09351 7.35338 2.09351 7.20188Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="switch-account-label">{{ flyoutData.translations.switchAccount }}</div>
            </div>
          </div>
        </div>
        <div class="menusection" role="menu" aria-label="Account actions">
          <div
            class="menuentry-link"
            [class.menuentry-label]="menuEntry.entries?.length > 0"
            *ngFor="let menuEntry of accountFlyoutData.selectedContext?.menuEntries"
            role="none"
          >
            <a
              *ngIf="!menuEntry.entries?.length; else submenuTrigger"
              (click)="handleCSSLinks($event, menuEntry?.url)"
              class="account-label menu-entry"
              href="{{ menuEntry.url }}"
              role="menuitem"
              tabindex="0"
            >
              {{ menuEntry.label }}
            </a>

            <ng-template #submenuTrigger>
              <div
                class="menuentry account-label"
                (click)="openSubmenu(menuEntry.entries)"
                (keydown.enter)="openSubmenu(menuEntry.entries)"
                (keydown.space)="openSubmenu(menuEntry.entries); $event.preventDefault()"
                (click)="toggleSubmenu(menuEntry.entries)"
                (keydown.enter)="toggleSubmenu(menuEntry.entries)"
                (keydown.space)="toggleSubmenu(menuEntry.entries); $event.preventDefault()"
                role="menuitem"
                [attr.aria-expanded]="!!submenuEntries"
                [attr.aria-controls]="'submenu-' + menuEntry.id"
                tabindex="0"
              >
                {{ menuEntry.label }}
              </div>
              <div class="arrow-right" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 32 32"
                  version="1.1"
                >
                  <defs>
                    <path
                      d="M12.300423,7.285875 C12.694423,6.898875 13.328423,6.904875 13.714423,7.299875 L21.714423,15.463875 C22.095423,15.852875 22.095423,16.475875 21.714423,16.863875 L14.035423,24.699875 C13.648423,25.094875 13.015423,25.100875 12.620423,24.713875 C12.226423,24.326875 12.221423,23.694875 12.606423,23.299875 L19.600423,16.163875 L12.286423,8.699875 C12.095423,8.504875 12.000423,8.252875 12.000423,7.999875 C12.000423,7.739875 12.100423,7.480875 12.300423,7.285875 Z"
                      id="pathlink"
                    ></path>
                  </defs>
                  <g id="Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Icon-/-medium-/-chevron-right">
                      <rect id="fill" x="0" y="0" width="32" height="32"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#pathlink"></use>
                      </mask>
                      <use id="color" fill="#002d72" xlink:href="#pathlink"></use>
                    </g>
                  </g>
                </svg>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="blue-section" *ngIf="!isCompanion" role="menu" aria-label="Business actions">
          <div class="register-business-link">
            <a
              class="account-label menu-entry"
              href="{{
                accountFlyoutData.selectedContext?.account?.actions?.registerBusiness ||
                  flyoutData.person?.actions?.registerBusiness
              }}"
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.9233 11.6527C13.5438 11.6527 13.2358 11.9628 13.2358 12.345V20.6191H11.1162V15.7791C11.1162 15.3963 10.8329 15.0869 10.4837 15.0869H6.19025C5.84031 15.0869 5.55706 15.3963 5.55706 15.7791V20.6191H3.4375V4.13445H8.7505C9.13 4.13445 9.438 3.82503 9.438 3.44223C9.438 3.06012 9.13 2.75 8.7505 2.75H2.75C2.3705 2.75 2.0625 3.06012 2.0625 3.44223V21.3114C2.0625 21.6942 2.3705 22.0036 2.75 22.0036H6.18544C6.18647 22.0036 6.18716 22.0039 6.18784 22.0043C6.18836 22.0045 6.18888 22.0048 6.18954 22.0049C6.18976 22.005 6.18999 22.005 6.19025 22.005H10.4837C10.4843 22.005 10.4849 22.0047 10.4856 22.0044C10.4864 22.004 10.4874 22.0036 10.4885 22.0036H13.9233C14.3034 22.0036 14.6108 21.6942 14.6108 21.3114V12.345C14.6108 11.9628 14.3034 11.6527 13.9233 11.6527ZM6.95131 20.5454H9.72331V16.3976H6.95131V20.5454ZM9.14237 10.8508C9.14237 10.47 8.83025 10.1585 8.44869 10.1585C8.06644 10.1585 7.75431 10.47 7.75431 10.8508V12.2359C7.75431 12.616 8.06644 12.9281 8.44869 12.9281C8.83025 12.9281 9.14237 12.616 9.14237 12.2359V10.8508ZM6.36625 10.8508C6.36625 10.47 6.05344 10.1585 5.67188 10.1585C5.29031 10.1585 4.9775 10.47 4.9775 10.8508V12.2359C4.9775 12.616 5.29031 12.9281 5.67188 12.9281C6.05344 12.9281 6.36625 12.616 6.36625 12.2359V10.8508ZM9.14237 6.69741C9.14237 6.31669 8.83025 6.00519 8.44869 6.00519C8.06644 6.00519 7.75431 6.31669 7.75431 6.69741V8.08187C7.75431 8.46259 8.06644 8.77409 8.44869 8.77409C8.83025 8.77409 9.14237 8.46259 9.14237 8.08187V6.69741ZM6.36625 6.69741C6.36625 6.31669 6.05344 6.00519 5.67188 6.00519C5.29031 6.00519 4.9775 6.31669 4.9775 6.69741V8.08187C4.9775 8.46259 5.29031 8.77409 5.67188 8.77409C6.05344 8.77409 6.36625 8.46259 6.36625 8.08187V6.69741ZM20.603 5.621C20.603 2.90055 18.4051 0.6875 15.7032 0.6875C13.0013 0.6875 10.8027 2.90055 10.8027 5.621C10.8027 8.34214 13.0013 10.5552 15.7032 10.5552C18.4051 10.5552 20.603 8.34214 20.603 5.621ZM12.2767 5.621C12.2767 3.71876 13.8133 2.17094 15.7032 2.17094C17.5931 2.17094 19.1304 3.71876 19.1304 5.621C19.1304 7.52393 17.5931 9.07175 15.7032 9.07175C13.8133 9.07175 12.2767 7.52393 12.2767 5.621ZM15.7032 2.78356C16.1095 2.78356 16.4402 3.11583 16.4402 3.52563V4.87963H17.7849C18.1919 4.87963 18.5212 5.21189 18.5212 5.621C18.5212 6.03149 18.1919 6.36307 17.7849 6.36307H16.4402V7.71706C16.4402 8.12755 16.1095 8.45913 15.7032 8.45913C15.2969 8.45913 14.9662 8.12755 14.9662 7.71706V6.36307H13.6214C13.2144 6.36307 12.8851 6.03149 12.8851 5.621C12.8851 5.21189 13.2144 4.87963 13.6214 4.87963H14.9662V3.52563C14.9662 3.11583 15.2969 2.78356 15.7032 2.78356Z"
                  fill="#002D72"
                />
              </svg>

              {{ flyoutData.translations.registerBusiness }}
            </a>
          </div>
          <div class="add-metro-card-link">
            <a
              class="account-label menu-entry"
              href="{{
                accountFlyoutData.selectedContext?.account?.actions?.addExistingCard ||
                  flyoutData.person?.actions?.addExistingCard
              }}"
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.25 15.125C19.25 15.5045 18.9427 15.8125 18.5625 15.8125H16.5V17.875C16.5 18.2545 16.1927 18.5625 15.8125 18.5625C15.4323 18.5625 15.125 18.2545 15.125 17.875V15.8125H13.0625C12.6823 15.8125 12.375 15.5045 12.375 15.125C12.375 14.7455 12.6823 14.4375 13.0625 14.4375H15.125V12.375C15.125 11.9955 15.4323 11.6875 15.8125 11.6875C16.1927 11.6875 16.5 11.9955 16.5 12.375V14.4375H18.5625C18.9427 14.4375 19.25 14.7455 19.25 15.125ZM3.63963 4.125H18.3604C19.9884 4.125 21.3125 5.39756 21.3125 6.96094V13.9439C21.3125 14.3234 21.0052 14.6314 20.625 14.6314C20.2448 14.6314 19.9375 14.3234 19.9375 13.9439V9.625H2.0625V15.7231C2.0625 16.5289 2.76994 17.1841 3.63963 17.1841H13.2646C13.6448 17.1841 13.9521 17.4921 13.9521 17.8716C13.9521 18.2511 13.6448 18.5591 13.2646 18.5591H3.63963C2.01163 18.5591 0.6875 17.2872 0.6875 15.7231V6.96094C0.6875 5.39756 2.01163 4.125 3.63963 4.125ZM2.0625 6.96094V8.25H19.9375V6.96094C19.9375 6.15519 19.2301 5.5 18.3604 5.5H3.63962C2.76994 5.5 2.0625 6.15519 2.0625 6.96094Z"
                  fill="#002D72"
                />
              </svg>

              {{ flyoutData.translations.addExistingCard }}
            </a>
          </div>
        </div>

        <div class="business-and-personal" role="region" aria-label="Personal account information">
          <div class="switch-account-details">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21">
              <path
                fill="#002d72"
                d="M24 12.2c0 3.4-1.4 6.5-3.7 8.6l-5.4-1.9v-2.6c1.6-1.2 2.6-3.3 2.6-5.5 0-3.6-2.5-6.5-5.5-6.5s-5.5 2.9-5.5 6.5c0 2.2 1 4.3 2.6 5.5v2.6l-5.4 1.9C1.4 18.6 0 15.6 0 12.2 0 5.6 5.4.2 12 .2s12 5.4 12 12z"
              ></path>
            </svg>
            <div class="personal-info personal-info-name">
              {{ userName }}
              <br />
              <span>{{ flyoutData?.translations?.personalAccount }}</span>
            </div>
          </div>
        </div>

        <div *ngFor="let pMenuEntry of accountFlyoutData.personal?.menuEntries" role="none">
          <a
            class="account-label menu-entry"
            href="{{ pMenuEntry.url }}"
            (click)="handleCSSLinks($event, pMenuEntry?.url)"
            role="menuitem"
            tabindex="0"
          >
            {{ pMenuEntry.label }}
          </a>
        </div>
        <div role="none">
          <a
            class="account-label idam-logout"
            href="/"
            (click)="logout($event)"
            *ngIf="!isCompanion"
            role="menuitem"
            tabindex="0"
            aria-label="Logout from your account"
          >
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8329 17.4863C15.455 17.4863 15.1496 17.7936 15.1496 18.1738V18.8317H9.38671V3.16843H15.1496V4.72287C15.1496 5.10237 15.455 5.41037 15.8329 5.41037C16.21 5.41037 16.5161 5.10237 16.5161 4.72287V2.48093C16.5161 2.10143 16.21 1.79343 15.8329 1.79343H9.38671V0.687243C9.38671 0.47893 9.29243 0.281618 9.13051 0.150993C8.96995 0.0203677 8.75747 -0.0284448 8.55524 0.0162427L0.534959 1.80993C0.222045 1.87937 0 2.15849 0 2.48093V19.5192C0 19.841 0.222045 20.1208 0.534959 20.1902L8.55524 21.9839C8.60443 21.9942 8.6543 21.9997 8.7035 21.9997C8.8579 21.9997 9.00889 21.9475 9.13119 21.8485C9.29243 21.7179 9.38671 21.5212 9.38671 21.3122V20.2067H15.8329C16.21 20.2067 16.5161 19.8987 16.5161 19.5192V18.1738C16.5161 17.7936 16.21 17.4863 15.8329 17.4863ZM8.02028 20.4556L1.36643 18.9679V3.03231L8.02028 1.54456V20.4556ZM21.6625 10.9622C21.791 11.0908 21.8627 11.2661 21.8627 11.4483C21.8627 11.449 21.8626 11.4495 21.8624 11.45C21.8622 11.4505 21.862 11.451 21.862 11.4517C21.862 11.4524 21.8622 11.4531 21.8624 11.4538C21.8626 11.4545 21.8627 11.4551 21.8627 11.4558C21.8627 11.6559 21.7746 11.8326 21.6393 11.9577L18.0975 15.521C17.9643 15.6551 17.7894 15.7225 17.6145 15.7225C17.4396 15.7225 17.2654 15.6551 17.1315 15.521C16.865 15.2522 16.865 14.817 17.1315 14.5489L19.5227 12.1433H11.8229C11.445 12.1433 11.1396 11.8353 11.1396 11.4558C11.1396 11.0756 11.445 10.7683 11.8229 10.7683H19.5377L17.1315 8.34696C16.865 8.07883 16.865 7.64364 17.1315 7.37483C17.3986 7.10671 17.8311 7.10671 18.0975 7.37483L21.6625 10.9622Z"
                fill="#002D72"
              />
            </svg>
            {{ flyoutData.translations.logout }}
          </a>
        </div>
      </div>

      <div
        class="secondary-flyout"
        [class.open]="isContextsMenuOpened"
        id="context-menu"
        role="menu"
        aria-label="Switch between accounts"
      >
        <div
          class="back-section"
          (click)="toggleContextsMenu($event)"
          (keydown.enter)="toggleContextsMenu($event)"
          (keydown.space)="toggleContextsMenu($event); $event.preventDefault()"
          tabindex="0"
          role="button"
          aria-label="Go back to main menu"
        >
          <div class="back-svg" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 32 32"
              version="1.1"
            >
              <defs>
                <path
                  d="M27,15.00125 L7.414,15.00125 L14.709,7.70725 C15.1,7.31625 15.1,6.68325 14.709,6.29325 C14.318,5.90225 13.686,5.90225 13.295,6.29325 L4.294,15.29325 C4.202,15.38525 4.129,15.49525 4.078,15.61625 C4.027,15.73725 4,15.86825 4,16.00125 C4,16.13425 4.027,16.26525 4.078,16.38625 C4.129,16.50725 4.202,16.61725 4.294,16.70925 L13.295,25.70925 C13.49,25.90525 13.746,26.00225 14.002,26.00225 C14.258,26.00225 14.514,25.90525 14.709,25.70925 C15.1,25.31925 15.1,24.68625 14.709,24.29525 L7.414,17.00125 L27,17.00125 C27.553,17.00125 28,16.55325 28,16.00125 C28,15.44925 27.553,15.00125 27,15.00125"
                  id="path-4"
                ></path>
              </defs>
              <g id="Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-/-medium-/-arrow-left">
                  <polygon id="fill" points="0 0 32 0 32 32 0 32"></polygon>
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-4"></use>
                  </mask>
                  <use id="color" fill="#0064fe" xlink:href="#path-4"></use>
                </g>
              </g>
            </svg>
          </div>
          <div class="back-label">{{ flyoutData.translations.back }}</div>
        </div>
        <div
          *ngFor="let context of accountFlyoutData.contexts"
          (click)="context.id !== accountFlyoutData.selectedContext?.id && switchContext(context.id)"
          (keydown.enter)="context.id !== accountFlyoutData.selectedContext?.id && switchContext(context.id)"
          (keydown.space)="
            context.id !== accountFlyoutData.selectedContext?.id && switchContext(context.id); $event.preventDefault()
          "
          class="secondary-account-info"
          [class.activeUser]="context.id === accountFlyoutData.selectedContext?.id"
          role="menuitemradio"
          [attr.aria-checked]="context.id === accountFlyoutData.selectedContext?.id"
          tabindex="0"
        >
          <div class="switchflyoutaccount">
            <div class="account-info">
              <div *ngIf="context.isHeadQuarter">
                <span class="admin-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.7445 9H12.4731V1.6875C12.4731 1.377 12.2193 1.125 11.9052 1.125H2.81795C2.50444 1.125 2.25 1.377 2.25 1.6875V16.3125C2.25 16.623 2.50444 16.875 2.81795 16.875H5.65771H9.06543H11.9052C11.9819 16.875 12.0546 16.8593 12.121 16.8322C12.1875 16.8593 12.2602 16.875 12.3368 16.875H15.7445C16.0586 16.875 16.3125 16.623 16.3125 16.3125V9.5625C16.3125 9.252 16.0586 9 15.7445 9ZM12.4731 15.75H15.1766V10.125H12.4731V15.75ZM9.63338 15.75H11.3372V2.25H3.3859V15.75H5.08976V11.8125C5.08976 11.502 5.3442 11.25 5.65771 11.25H9.06543C9.37951 11.25 9.63338 11.502 9.63338 11.8125V15.75ZM6.22567 15.75H8.49748V12.375H6.22567V15.75ZM13.1899 11.6657V12.7907C13.1899 13.1001 13.4455 13.3532 13.7578 13.3532C14.0708 13.3532 14.3258 13.1001 14.3258 12.7907V11.6657C14.3258 11.3563 14.0708 11.1032 13.7578 11.1032C13.4455 11.1032 13.1899 11.3563 13.1899 11.6657ZM9.21934 8.95388V7.82888C9.21934 7.5195 9.47492 7.26638 9.7873 7.26638C10.0997 7.26638 10.3552 7.5195 10.3552 7.82888V8.95388C10.3552 9.26325 10.0997 9.51638 9.7873 9.51638C9.47492 9.51638 9.21934 9.26325 9.21934 8.95388ZM6.94753 7.82888V8.95388C6.94753 9.26325 7.20311 9.51638 7.51549 9.51638C7.82786 9.51638 8.08344 9.26325 8.08344 8.95388V7.82888C8.08344 7.5195 7.82786 7.26638 7.51549 7.26638C7.20311 7.26638 6.94753 7.5195 6.94753 7.82888ZM4.67572 8.95388V7.82888C4.67572 7.5195 4.9313 7.26638 5.24368 7.26638C5.55605 7.26638 5.81163 7.5195 5.81163 7.82888V8.95388C5.81163 9.26325 5.55605 9.51638 5.24368 9.51638C4.9313 9.51638 4.67572 9.26325 4.67572 8.95388ZM9.21934 4.45388V5.57888C9.21934 5.88825 9.47492 6.14138 9.7873 6.14138C10.0997 6.14138 10.3552 5.88825 10.3552 5.57888V4.45388C10.3552 4.1445 10.0997 3.89138 9.7873 3.89138C9.47492 3.89138 9.21934 4.1445 9.21934 4.45388ZM6.94753 5.57888V4.45388C6.94753 4.1445 7.20311 3.89138 7.51549 3.89138C7.82786 3.89138 8.08344 4.1445 8.08344 4.45388V5.57888C8.08344 5.88825 7.82786 6.14138 7.51549 6.14138C7.20311 6.14138 6.94753 5.88825 6.94753 5.57888ZM4.67572 4.45388V5.57888C4.67572 5.88825 4.9313 6.14138 5.24368 6.14138C5.55605 6.14138 5.81163 5.88825 5.81163 5.57888V4.45388C5.81163 4.1445 5.55605 3.89138 5.24368 3.89138C4.9313 3.89138 4.67572 4.1445 4.67572 4.45388Z"
                      fill="#002D72"
                    />
                  </svg>
                  {{ 'CORE.ALL_PAGES.FLYOUT.KEY_ACCOUNTS.ADMIN' | translate }}:
                </span>
                <br />
              </div>
              <strong>{{ context.label }}</strong>
              <br />
              <span>{{ context.footer }}</span>
            </div>
            <div *ngIf="context.id === accountFlyoutData.selectedContext?.id" class="selectedCheckbox">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="30px"
                height="32px"
                viewBox="0 0 32 32"
                version="1.1"
              >
                <defs>
                  <path
                    d="M13.0514,24.0001 C12.7734,24.0001 12.5064,23.8841 12.3174,23.6791 L5.2654,16.0551 C4.8904,15.6491 4.9154,15.0171 5.3214,14.6421 C5.7254,14.2661 6.3574,14.2911 6.7344,14.6971 L13.0514,21.5271 L25.2654,8.3211 C25.6404,7.9151 26.2724,7.8911 26.6784,8.2661 C27.0834,8.6411 27.1094,9.2731 26.7344,9.6791 L13.7854,23.6791 C13.5964,23.8841 13.3294,24.0001 13.0514,24.0001"
                    id="pathcheck"
                  ></path>
                </defs>
                <g id="Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Icon-/-medium-/-check">
                    <rect id="fill" x="0" y="0" width="32" height="32"></rect>
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#pathcheck"></use>
                    </mask>
                    <use id="color" fill="#005AE0" xlink:href="#pathcheck"></use>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        class="submenu submenu-1"
        [class.open]="!!submenuEntries"
        id="submenu-1"
        role="menu"
        aria-label="Submenu"
      >
        <div
          class="back-section"
          (click)="closeSubmenu($event)"
          (keydown.enter)="closeSubmenu($event)"
          (keydown.space)="$event.preventDefault(); closeSubmenu($event)"
          tabindex="0"
          role="button"
          aria-label="Go back to main menu"
        >
          <div class="back-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 32 32"
              version="1.1"
            >
              <defs>
                <path
                  d="M27,15.00125 L7.414,15.00125 L14.709,7.70725 C15.1,7.31625 15.1,6.68325 14.709,6.29325 C14.318,5.90225 13.686,5.90225 13.295,6.29325 L4.294,15.29325 C4.202,15.38525 4.129,15.49525 4.078,15.61625 C4.027,15.73725 4,15.86825 4,16.00125 C4,16.13425 4.027,16.26525 4.078,16.38625 C4.129,16.50725 4.202,16.61725 4.294,16.70925 L13.295,25.70925 C13.49,25.90525 13.746,26.00225 14.002,26.00225 C14.258,26.00225 14.514,25.90525 14.709,25.70925 C15.1,25.31925 15.1,24.68625 14.709,24.29525 L7.414,17.00125 L27,17.00125 C27.553,17.00125 28,16.55325 28,16.00125 C28,15.44925 27.553,15.00125 27,15.00125"
                  id="path-4"
                ></path>
              </defs>
              <g id="Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-/-medium-/-arrow-left">
                  <polygon id="fill" points="0 0 32 0 32 32 0 32"></polygon>
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-4"></use>
                  </mask>
                  <use id="color" fill="#0064fe" xlink:href="#path-4"></use>
                </g>
              </g>
            </svg>
          </div>
          <div class="back-label">{{ flyoutData.translations.back }}</div>
        </div>
        <div class="submenu-section" *ngFor="let entry of submenuEntries" role="none">
          <div class="submenu-info">
            <a class="menu-entry" href="{{ entry.url }}" role="menuitem" tabindex="0">
              <strong>{{ entry.label }}</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- COMP_MONITORING:COMP_OK -->
  </div>
</div>
